import { AxiosResponse } from "axios";
import endpoints from "../core/endpoints";
import request from "../core/request";
import { GetCodeRequest, LoginRequest } from "../types/auth";
import { User } from "../types/user";

export const getCode = async (
  reqData: GetCodeRequest
): Promise<AxiosResponse> => {
  const data = await request.post(endpoints.getCode, reqData);
  return data;
};

export const login = async (reqData: LoginRequest): Promise<User> => {
  const { data } = await request.post(endpoints.login, reqData);
  return data;
};
